import { motion } from "framer-motion";
import {
    Compass,
    Megaphone,
    MonitorSmartphone,
    Sparkles,
    BarChart3,
    Star,
    Zap,
    ArrowUpRight,
} from "lucide-react";
import { SERVICES } from "@/lib/constants";

const ICONS = {
    Compass,
    Megaphone,
    MonitorSmartphone,
    Sparkles,
    BarChart3,
    Star,
};

export default function Services() {
    return (
        <section
            id="services"
            data-testid="services-section"
            className="relative py-24 md:py-32 bg-white"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14 md:mb-20">
                    <div>
                        <div className="inline-flex items-center gap-2 text-ae-orange text-xs font-bold uppercase tracking-[0.22em]">
                            <Zap className="h-4 w-4" /> What We Do
                        </div>
                        <h2 className="mt-5 font-display font-extrabold text-4xl md:text-5xl lg:text-6xl text-ae-ink tracking-tight leading-[1.02]">
                            Six disciplines.
                            <br />
                            <span className="text-ae-orange">One amplified</span> outcome.
                        </h2>
                    </div>
                    <p className="md:max-w-md text-base md:text-lg text-ae-gray-700">
                        We blend strategic thinking, world-class creative, AI tooling and
                        custom software to deliver work that moves brands forward.
                    </p>
                </div>

                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                    {SERVICES.map((s, i) => {
                        const Icon = ICONS[s.icon];
                        return (
                            <motion.a
                                key={s.id}
                                href="#contact"
                                data-testid={`service-card-${s.id}`}
                                initial={{ opacity: 0, y: 24 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-80px" }}
                                transition={{
                                    duration: 0.7,
                                    delay: i * 0.08,
                                    ease: [0.22, 1, 0.36, 1],
                                }}
                                className="group relative bg-white border border-black/5 rounded-3xl p-7 md:p-8 shadow-ae-soft hover:shadow-ae-lift hover:border-ae-orange/50 hover:-translate-y-1 transition-all duration-500 overflow-hidden"
                            >
                                <div className="absolute -top-20 -right-20 h-48 w-48 rounded-full bg-ae-orange/0 group-hover:bg-ae-orange/10 transition-colors duration-500 blur-2xl" />
                                <div className="relative">
                                    <div className="h-14 w-14 rounded-2xl bg-ae-orange/10 text-ae-orange flex items-center justify-center group-hover:bg-ae-orange group-hover:text-white transition-all duration-500">
                                        {Icon ? <Icon className="h-7 w-7" /> : null}
                                    </div>
                                    <h3 className="mt-6 font-display font-bold text-xl md:text-2xl text-ae-ink leading-tight">
                                        {s.title}
                                    </h3>
                                    <p className="mt-3 text-sm md:text-base text-ae-gray-700 leading-relaxed">
                                        {s.desc}
                                    </p>
                                    <div className="mt-7 flex items-center gap-2 text-sm font-semibold text-ae-ink group-hover:text-ae-orange transition-colors">
                                        Learn more
                                        <ArrowUpRight className="h-4 w-4 group-hover:rotate-45 transition-transform" />
                                    </div>
                                </div>
                            </motion.a>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
